var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"height":"450px","interval":15000}},_vm._l((_vm.swiperList),function(item,index){return _c('el-carousel-item',{key:index},[_c('Link',{attrs:{"to":item.url,"target":"_blank"}},[_c('img',{staticClass:"link-item",attrs:{"src":item.adImage,"alt":""}})])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }